module.exports = __webpack_public_path__ + "media/components/assets/icons/label_live_finished-e21c10c709c4f34abb808d737fb62c54.svg";